<template>
  <div class="base-card-info mb-0">
    <div class="info-card-title">
      基本信息
    </div>
    <div class="custom-base-info">
      <!-- 业务线 -->
      <div v-if="!isHnFreePartners" class="item">
        <div class="label">
          业务线
        </div>
        <div class="value">
          {{ info?.businessName || '--' }}
        </div>
      </div>
      <!-- 审批发起人 -->
      <div class="item">
        <div class="label">
          审批发起人
        </div>
        <div class="value">
          {{ info?.submitter || '--' }}
        </div>
      </div>
      <!-- 公司名称 -->
      <div class="item">
        <div class="label">
          公司名称
        </div>
        <div class="value">
          {{ info?.submitCompanyName || '--' }}
        </div>
      </div>
      <!-- 审批发起时间 -->
      <div class="item">
        <div class="label">
          审批发起时间
        </div>
        <div class="value">
          {{ info?.submitTime || '--' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang='ts'>
import { computed, PropType } from 'vue';
import { IApproveTaskDetail } from '@core/main/types/system/approval';
import { ESystemType } from '@core/api';
import { serverCrowdCreditCode } from '@core/main/types';
import { useUserStore } from '@core/main';

const { state: userState } = useUserStore();

defineProps({
  info: {
    type: Object as PropType<IApproveTaskDetail>,
    default: () => ({}),
  },
});

const isServer = computed(() => userState.identity.systemType === ESystemType.Server);
const isHnFreePartners = computed(() => serverCrowdCreditCode?.includes(userState.identity?.serverDTO?.creditCode) && isServer.value);
</script>
